import { Component, OnInit } from '@angular/core';
import { collection, getDocs } from "firebase/firestore";
import { ProductListService } from 'src/app/service/product-list.service';
import { ProductServiceService } from 'src/app/service/product-service.service';

@Component({
    selector: 'app-new-products',
    templateUrl: './new-products.component.html',
    styleUrls: ['./new-products.component.scss']
})
export class NewProductsComponent implements OnInit {
    singleProductsItem=[];
    constructor(private productService:ProductServiceService) {
        productService.getNewProducts().subscribe(res=>{
            this.singleProductsItem =  res;
            console.log("New Products "+JSON.stringify(res));
        })
       
     }

    ngOnInit() {

    }

    sectionTitle = [
        {
            title: "New Products",
           // paragraph: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Quis ipsum suspendisse ultrices gravida."
        }
    ]
   

}